import { SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/components/common/api';
import { Observable } from 'rxjs/Observable';
import { User, UserApplication, UserComplex } from '../../../models/user.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { RolesService } from '../../../services/user/roles.service';
import { UsersService } from '../../../services/user/users.service';
import { AuthService } from './../../../services/user/auth.service';

@Component({
  selector: 'app-company-admin',
  templateUrl: './company-admin.component.html',
  styleUrls: ['./company-admin.component.css']
})
export class CompanyAdminComponent implements OnInit {

  customButtons: DataTableCustomButton[];
  userSelected: User = null;
  newDataAvailable = false;
  showDialog = false;
  showPswDialog = false;
  comboOptions: SelectItem[];
  customFilter = KontableComponent.CustomFilter;
  numberFilter = KontableComponent.NumberFilter;
  dialogTitlesList: any = {};
  dialogTitle: string;
  usersList;
  paginationType = KontableComponent.ServerPagination;
  userId: number;
  selectedApplications: UserApplication[] = [];
  dialogApplications = false;
  companyId: number;
  externalUserOptions: SelectItem[];

  constructor (
    public srvUsers: UsersService,
    public srvDataTable: DataTableService,
    public translate: TranslateService,
    public srvRoles: RolesService,
    public confirmationService: ConfirmationService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {

   const translateGet = this.translate.get([
      'users.add_title',
      'users.edit_title',
      'common.all',
      'userForm.externalUser',
      'userForm.internalUser'
    ]);

    const rolesGetAll = this.srvRoles.getAll();
    Observable.zip(
      translateGet,
      rolesGetAll,
    ).subscribe(([resTranslate, resRolesGetAll]) => {
      this.dialogTitlesList.add_title = resTranslate['users.add_title' ];
      this.dialogTitlesList.edit_title = resTranslate['users.edit_title'];

      this.externalUserOptions = [{label: resTranslate['common.all'], value: null}];
      this.externalUserOptions.push({label: resTranslate['userForm.internalUser'], value: '0'});
      this.externalUserOptions.push({label: resTranslate['userForm.externalUser'], value: '1'});

      this.comboOptions = [{label: resTranslate['common.all'], value: null}];

      resRolesGetAll.forEach((r) => {
          this.comboOptions.push({label: r.descr, value: r.descr});
      });
    });

    this.companyId = this.authService.user.selectedCompany;

  }

  showAddOrEditDialog(data): void {
    let uc = new UserComplex();
    uc.user = (data) ? data : new User();
    this.dialogTitle = data ? this.dialogTitlesList.edit_title : this.dialogTitlesList.add_title;
    this.srvUsers.userEditing = uc;
    this.showDialog = true;
  }

  delete(record): void {
    this.srvUsers.delete(record).subscribe( () => {
      this.newDataAvailable = true;
    });
  }

  userAdded(row): void {
    row.user.email = row.user.email.toLowerCase ();
    this.srvUsers.post(row).subscribe(() => {
      this.srvDataTable.get('dt_users').showDetail = false;
      this.srvUsers.userEditing = null;
      this.srvUsers.getList().subscribe();
      this.newDataAvailable = true;
      this.closeDialog();
    });
  }

  userUpdated(row): void {
    row.user.email = row.user.email.toLowerCase ();
    this.srvUsers.put(row).subscribe(() => {
      this.srvDataTable.get('dt_users').showDetail = false;
      this.srvUsers.userEditing = null;
      this.newDataAvailable = true;
      this.closeDialog();
    })
  }

  resetPwdAction(newPsw: string) {
    this.translate.get(['userList.resetPasswordConfirmDescr', 'userList.resetPasswordConfirmHeader']).subscribe((res) => {
      this.confirmationService.confirm({
        message: res['userList.resetPasswordConfirmDescr'],
        header: res['userList.resetPasswordConfirmHeader'],
        accept: () => {
          this.srvUsers.newResetPassword(this.userId, newPsw).subscribe(() => this.showPswDialog = false);
        }
      });
    });
  }

  openPswResetDialog(row: User) {
    this.showPswDialog = true;
    this.userId = row.id;
  }

  closeDialog() {
    this.showDialog = false;
  }

  userApplication(row) {
    this.userSelected = row;
    this.srvUsers.getApplicationsForUserCompany(row.id, this.companyId).subscribe(
      res => this.selectedApplications = res,
      err => console.error(err),
      () => this.dialogApplications = true
    )
  }

  userStoresAndSalesNetworks(row) {
    this.router.navigateByUrl(`user-stores-and-sales-networks/${row.id}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/company-admin.component.ts